module.exports = __webpack_public_path__ + "static/media/me.05418137.png";